import React, {PureComponent} from 'react'
import './Privacy.scss'

class index extends PureComponent {
    render() {
        return (
            <div>
                <div className="privacy-page">
                    <div className="privacy-container">
                        <h1>隐私政策</h1>

                        <p className="update-time">
                            更新时间：2026年6月
                        </p>

                        <p>
                            欢迎访问本网站。我们非常重视用户的个人信息和隐私保护。本隐私政策旨在说明我们如何收集、使用、存储和保护您的个人信息。
                        </p>

                        <h2>一、信息收集</h2>

                        <p>
                            在您使用本网站服务过程中，我们可能会收集以下信息：
                        </p>

                        <h3>1. 您主动提交的信息</h3>

                        <ul>
                            <li>姓名</li>
                            <li>手机号码</li>
                            <li>微信号</li>
                            <li>电子邮箱</li>
                            <li>车辆品牌、车型、车架号（VIN）、车牌号等车辆信息</li>
                        </ul>

                        <h3>2. 系统自动收集的信息</h3>

                        <ul>
                            <li>IP地址</li>
                            <li>浏览器类型</li>
                            <li>访问时间</li>
                            <li>设备信息</li>
                            <li>Cookie信息</li>
                        </ul>

                        <h2>二、信息使用目的</h2>

                        <p>
                            我们收集的信息将用于以下用途：
                        </p>

                        <ul>
                            <li>提供车辆估价服务；</li>
                            <li>联系用户并沟通车辆收购事宜；</li>
                            <li>回应用户咨询和服务请求；</li>
                            <li>改进网站功能和用户体验；</li>
                            <li>满足法律法规要求。</li>
                        </ul>

                        <h2>三、信息存储与保护</h2>

                        <p>
                            我们将采取合理的技术和管理措施保护您的个人信息，防止未经授权的访问、披露、篡改或丢失。
                        </p>

                        <p>
                            除法律法规另有规定外，我们不会向无关第三方出售、出租或提供您的个人信息。
                        </p>

                        <h2>四、Cookie技术</h2>

                        <p>
                            为改善用户体验，本网站可能使用Cookie或类似技术记录您的访问行为。
                        </p>

                        <p>
                            您可以通过浏览器设置拒绝或删除Cookie，但部分功能可能因此无法正常使用。
                        </p>

                        <h2>五、信息共享</h2>

                        <p>
                            在以下情况下，我们可能依法共享您的个人信息：
                        </p>

                        <ul>
                            <li>获得您的明确授权；</li>
                            <li>根据法律法规要求；</li>
                            <li>根据司法机关或行政机关的合法要求；</li>
                            <li>为维护本公司合法权益所必需。</li>
                        </ul>

                        <h2>六、用户权利</h2>

                        <p>您有权：</p>

                        <ul>
                            <li>查询您的个人信息；</li>
                            <li>更正您的个人信息；</li>
                            <li>删除您的个人信息；</li>
                            <li>撤回授权同意。</li>
                        </ul>

                        <p>
                            如需行使上述权利，请通过本政策提供的联系方式与我们联系。
                        </p>

                        <h2>七、隐私政策更新</h2>

                        <p>
                            我们可能根据业务发展或法律法规要求对本隐私政策进行修订。更新后的内容将在本页面公布。
                        </p>

                        <h2>八、联系我们</h2>

                        <p><strong>公司名称：</strong>北京车兄弟科技有限公司</p>

                        <p><strong>联系邮箱：</strong>chexiongdi@126.com</p>

                        <p><strong>联系电话：</strong>400-679-0900 (9:00-18:00)</p>

                        <p><strong>网站地址：</strong>https://www.chexd.com/</p>

                        <p>
                            如您对本隐私政策有任何疑问，请随时与我们联系。
                        </p>

                    </div>
                </div>
            </div>
        )
    }
}

export default index